export function barWidth(percent: number): string {
  return `${Math.min(100, Math.max(0, Math.round(percent)))}%`;
}

export function ProgressBar({ percent, met }: { percent: number; met: boolean }) {
  return (
    <div
      className="h-3 w-full overflow-hidden rounded-full bg-stone-200"
      role="progressbar"
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={met ? "h-full bg-emerald-600" : "h-full bg-stone-800"}
        style={{ width: barWidth(percent) }}
      />
    </div>
  );
}
